/**
 * Progress Query Keys
 *
 * Centralized query key factory for matter progress queries.
 */

export const progressKeys = {
  /**
   * Root key for all progress queries
   */
  all: ['progress'] as const,

  /**
   * Progress for a specific matter
   * @param matterId - The matter ID
   */
  forMatter: (matterId: number) => [...progressKeys.all, matterId] as const
} as const;
